export enum LanguageCode {
  en = 'en',
  es = 'es',
  'es-sa' = 'es-sa',
  'fr' = 'fr',
  'fr-qc' = 'fr-qc'
}

export const defaultLocale: LanguageCode = LanguageCode.en;
